import * as Yup from 'yup';

export const BusinessSchema = Yup.object().shape({
    businessName: Yup.string().required("business name is a required field"),
    description: Yup.string().required("description is a required field"),
});

export const initialBusiness = {
    businessName: "",
    description: "",
} 

export const GroupSchema = Yup.object().shape({
    groupName: Yup.string().required("group name is a required field"),
    description: Yup.string().required("description is a required field"),
})

export const initialGroup = {
    groupName: "",
    description: "",
}